module.exports = __webpack_public_path__ + "images/icons/send-a-message.0438633a224b7613e024a16da449497a.png";